import { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import type {
  ConversationPriority,
  ConversationStatus,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import { useHandler } from "@redotech/react-util/hook";
import { useGlobalConversationCollections } from "../providers/support-providers";

/**
 * Returns a function to update a conversation's status.
 */
export function useUpdateConversationStatus(): (
  conversationId: ConversationId,
  status: ConversationStatus,
) => void {
  const collections = useGlobalConversationCollections();

  return useHandler(
    (conversationId: ConversationId, status: ConversationStatus) => {
      collections.conversationsList.update(conversationId, (draft) => {
        draft.status = status;
      });
    },
  );
}

/**
 * Returns a function to update a conversation's priority.
 */
export function useUpdateConversationPriority(): (
  conversationId: ConversationId,
  priority: ConversationPriority | null,
) => void {
  const collections = useGlobalConversationCollections();

  return useHandler(
    (conversationId: ConversationId, priority: ConversationPriority | null) => {
      collections.conversationsList.update(conversationId, (draft) => {
        draft.priority = priority;
      });
    },
  );
}
